import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Eierforhold from './Eierforhold'
import EierforholdIcon from '../../../images/Eierforhold.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class EierforholdList extends Component {
    state = {
        eierforhold: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null
    }

    getEierforhold = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/eier/${this.props.eierId}/eierforhold`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                eierforhold: [...this.state.eierforhold, ...data.eierforhold],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
      }


    toggleEierforhold = () => {
        if (this.props.antall == 0) return

        if (this.state.eierforhold.length == 0) {
            this.getEierforhold()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var antallEierforhold = this.state.continuationToken ? `${this.state.eierforhold.length}/${this.props.antall}` : this.props.antall

        return (
            <li>
                <div className="section-header" onClick={this.toggleEierforhold}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={EierforholdIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('eierforhold')} ({antallEierforhold})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.eierforhold.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.eierforhold.map((e, index) => {return (<Eierforhold key={e.eierforholdId} eierforhold={e} antall={this.props.antall} isLast={index==this.state.eierforhold.length-1} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getEierforhold}>
                                <span>{t('hent.eierforhold')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(EierforholdList)